import React, { useState, useRef, useEffect } from "react";
import "./CustomTooltip.css";

const CustomTooltip = ({ msg, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  useEffect(() => {
    if (showTooltip) {
      const tooltipElement = tooltipRef.current;
      const tooltipRect = tooltipElement.getBoundingClientRect();

      if (tooltipRect.right > window.innerWidth) {
        tooltipElement.style.left = "auto";
        tooltipElement.style.right = "0";
      }

      if (tooltipRect.left < 0) {
        tooltipElement.style.left = "0";
      }

      if (tooltipRect.bottom > window.innerHeight) {
        tooltipElement.style.bottom = "100%";
        tooltipElement.style.top = "auto";
      }
    }
  }, [showTooltip]);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="custom-tooltip-container"
    >
      {children}
      {showTooltip && (
        <span ref={tooltipRef} className="custom-tooltip">
          {msg}
        </span>
      )}
    </div>
  );
};

export default CustomTooltip;
